import { getAreas } from './getAreas'

export const AreasApi = {
    getAreas,
}
